import { Injectable, Injector } from '@angular/core';

import { of } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import {
	map,
	switchMap,
	catchError,
	withLatestFrom,
    filter
} from 'rxjs/operators';
import * as cobrandInfo from '../../actions';
import * as fromRoot from '../../reducers';
import { MicroServicesService } from '../../modules/core/services/micro-services.service';
import { FeatureFlagsService } from 'src/app/modules/core/services/feature-flags.service';
@Injectable()
export class CobrandInfoEffects {
  private microServicesService: MicroServicesService;

  private featureFlagService: FeatureFlagsService;

	constructor(
    private readonly injector : Injector,
		private readonly actions$: Actions,
		private readonly store: Store<fromRoot.AppState>
	) {
    this.injectServices();
  }

  injectServices() {
    this.microServicesService = this.injector.get<MicroServicesService>(MicroServicesService);
  }

  loadCobrandProgram$ = createEffect(() => {
    const cobrandData$ = this.store.pipe(select(fromRoot.getContentCobrandState));
    return this.actions$.pipe(
    ofType(cobrandInfo.CobrandInfoActionTypes.GET_COBRAND_INFO),
    withLatestFrom(cobrandData$),
    filter(([, cobrandData]) => !cobrandData || !cobrandData.loaded),
    map(([action]) => (action as any).payload),
    switchMap((payload: { accountId: string }) =>
        this.microServicesService.getCobrandInfo(payload.accountId).pipe(
        map((res) => {
            return new cobrandInfo.GetCobrandInfoSuccess({
                raw: res?.payload,
                lastUpdated: new Date().toISOString(),
            });
        }),
        catchError((error) => {
            return of(new cobrandInfo.GetCobrandInfoFailure({ payload: error }));
        })
        )
    )
    );
   });
}